import React from 'react';
import { Provider } from 'react-redux';
import widgetTypes from 'platform/site-wide/widgetTypes';
import startReactApp from '../../startup/react';
import SiteWideMessage, {
  SITE_WIDE_MESSAGE,
} from './components/SiteWideMessage';

const normalizePath = path => path.replace(/\/+$/, '');

// The homepage (current and redesigned share `/`) and the page the link points to.
const EXCLUDED_PATHS = ['', normalizePath(SITE_WIDE_MESSAGE.href)];

const isExcludedPath = () =>
  EXCLUDED_PATHS.includes(normalizePath(window.location.pathname));

// Mounts right after the header so it appears on every page without content-build markup.
export const startSiteWideMessage = store => {
  if (!store || document.getElementById('site-wide-message-root')) return;
  if (isExcludedPath()) return;
  // #header-minimal is only in the DOM on pages that use the minimal header (e.g. forms).
  if (document.getElementById('header-minimal')) return;

  const headerWidget = document.querySelector('[data-widget-type="header"]');
  // Pages that hide the VA.gov header (data-show="false") shouldn't get the message.
  if (headerWidget?.dataset.show === 'false') return;

  // Place after the whole <header> landmark, not just the React header root inside it.
  const header = headerWidget?.closest('header') || headerWidget;
  if (!header?.parentNode) return;

  const root = document.createElement('div');
  root.id = 'site-wide-message-root';
  header.parentNode.insertBefore(root, header.nextSibling);

  startReactApp(
    <Provider store={store}>
      <SiteWideMessage />
    </Provider>,
    root,
  );
};

// Are you looking for where this is used?
// Search for `data-widget-type="banner"` and `data-widget-type="maintenance-banner"` to find all the places this React widget is used.
export default async store => {
  startSiteWideMessage(store);

  // Derive the banner elements to place the App.
  const maintenanceBanner = document.querySelector(
    `[data-widget-type="${widgetTypes.MAINTENANCE_BANNER}"]`,
  );

  // Create the maintenance banner component.
  if (maintenanceBanner) {
    const { default: MaintenanceBanner } = await import(
      /* webpackChunkName: "maintenance-banner-widget" */ './components/MaintenanceBanner'
    );

    startReactApp(
      <MaintenanceBanner {...maintenanceBanner.dataset} />,
      maintenanceBanner,
    );
  }
};
